// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__Kw5iR","boxTitle":"Qualiphy_boxTitle__2X-QM","box":"Qualiphy_box__2numg","toggleWrap":"Qualiphy_toggleWrap__2k0E-"};